import React from "react";
import logo from "../../assets/images/logo.svg";

const BrandLogo = () => {
  return (
    <>
      <img
        src={logo}
        width="150px"
        className="object-contain"
        alt="no images"
      />
    </>
  );
};

export default BrandLogo;
